import React from 'react';
import {Form, FormGroup, ControlLabel, FormControl, Button, Modal} from 'react-bootstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import {connect} from 'react-redux';
import SelectAsync from 'react-select/lib/Async';
import Datetime from 'react-datetime';

class EventFormModal extends React.Component{

    static contextTypes = { api:PropTypes.object, notifier: PropTypes.object };

    constructor( props,context){
        super(props);
        if( !props.editing ) {
            this.state = {
                form: {
                    name:'',
                    fromDate:null,
                    toDate:null,
                    congress:{value:{id:null,name:null},label:''}
                }
            };
        }
        else {
            this.state = {
                form: {
                    name: props.editing.name,
                    fromDate:props.editing.fromDate?moment(props.editing.fromDate):null,
                    toDate:props.editing.toDate?moment(props.editing.toDate):null,
                    congress:props.editing.congress?{value:props.editing.congress,label:props.editing.congress.name}:{value:null,label:''},
                }
            };
        }
        context.api.congresses.get(0,10);
        context.api.clocks.get();
    }

    loadCongresses = ( name )=>{ return this.context.api.congresses.get( 0, 10, undefined, {name:name})
        .then( (congresses=[])=> congresses.map( (congress)=>({value:congress, label: congress.name }) ) ) };

    onFormChange = ({target})=> this.setState( { form: { ...this.state.form, [target.name]:target.value}});

    getFormValue = ( name ) => {
        if(name==='congress') return {value:this.state.form.congress.value?this.state.form.congress.value.id:null, label:this.state.form.congress.value?this.state.form.congress.value.name:''};
        return this.state.form[name]? this.state.form[name]:'';
    };

    saveForm = ()=>{
        if( !this.state.form.name || !this.state.form.fromDate || !this.state.form.toDate) return this.context.notifier.error('No has llenado todos los campos');
        if( this.state.form.toDate && moment(this.state.form.toDate).isBefore(this.state.form.fromDate)) return this.context.notifier.error('La fecha de fin no puede ser inferior a la de inicio del evento');
        const event = {
            ...this.state.form,
            fromDate: this.state.form.fromDate.format('YYYY-MM-DD HH:mm'),
            toDate: this.state.form.toDate.format('YYYY-MM-DD HH:mm')
        };
        event.congress = event.congress.value?event.congress.value.id:null;
        const finish = ()=>{
            if( this.props.didSave ) this.props.didSave();
            else if( this.props.onHide ) this.props.onHide();
        };
        if (this.props.editing) this.context.api.events.edit(this.props.editing.id, event, '@Class.Events.Event.edit' ).then(finish);
        else this.context.api.events.create( event, '@Class.Events.Event.create').then(finish);
    };

    render(){
        const { onHide } = this.props;
        return (
            <Modal show={true}
                   onHide={ onHide }>
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.editing? 'Editar evento o taller' : 'Añadir evento o taller'}</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Form className='EventFormModal'>
                        <FormGroup>
                            <ControlLabel>Nombre:</ControlLabel>
                            <FormControl
                                autoFocus={true}
                                placeholder='Nombre del evento'
                                name='name'
                                value={ this.getFormValue('name') }
                                onChange={this.onFormChange}
                                required/>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Fecha de inicio:</ControlLabel>
                            <Datetime
                                value={this.getFormValue('fromDate')||null}
                                onChange={(date)=>this.onFormChange({target:{name:'fromDate', value:date}})}
                            />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Fecha de fin:</ControlLabel>
                            <Datetime
                                value={this.getFormValue('toDate')||null}
                                onChange={(date)=>this.onFormChange({target:{name:'toDate', value:date}})}
                            />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Congreso:</ControlLabel>
                            <SelectAsync
                                cacheOptions
                                value={this.getFormValue('congress')||null}
                                defaultOptions={this.props.congresses.map((congress)=>({value:congress,label:congress.name,id:congress.id}))}
                                placeholder='Nombre del congreso'
                                noOptionsMessage={()=>"Sin coincidencias"}
                                loadOptions={this.loadCongresses}
                                onChange={(congress)=>this.onFormChange({target:{name:"congress", value:congress}})}/>
                        </FormGroup>
                        <br/>
                        <Button
                            bsStyle='danger'
                            onClick={this.props.onHide}
                        >Cancelar</Button>
                        <Button
                            bsStyle='success'
                            className='pull-right'
                            onClick={this.saveForm}
                        >Guardar</Button>
                    </Form>
                </Modal.Body>
            </Modal>
        );
    }
}

const mapStateToProps = ( { api:{congresses=[],emailAddresses=[], clocks=[]}, loadingIds } )=>({congresses,clocks,emailAddresses});

export default connect(mapStateToProps)(EventFormModal);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Events/components/EventFormModal/index.jsx